import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {useEffect} from 'react';

import {RootState} from '../../../../../index';
import {getActiveUsersOverviewState} from '../../../../../selectors/fortnite-game/activeUsersSelector';
import {ActiveUsersOverviewState} from '../../../../../reducers/fortnite-game/activeUsersOverview.reducer';
import actionsOverview from '../../../../../actions/fortnite-game/activeUsersOverview.actions';
import {Option} from '../../../../../types';

export interface UseActiveUsersOverviewDataParams {
    selectedGames: Option[];
}

const useActiveUsersData = ({
    selectedGames
}: UseActiveUsersOverviewDataParams): ActiveUsersOverviewState => {
    const dispatch = useDispatch();

    const {peak, avg} = useSelector<RootState, ActiveUsersOverviewState>(
        getActiveUsersOverviewState,
        shallowEqual
    );

    useEffect(() => {
        if (selectedGames.length) {
            const requests = [
                {value: 'peak', since: 'all'},
                {value: 'peak', since: 'today'},
                {value: 'avg', since: 'all'},
                {value: 'avg', since: 'today'}
            ];

            requests.forEach(params => {
                dispatch(
                    actionsOverview.getActiveUsersOverview({
                        islands: selectedGames.map(({value}) => value),
                        ...params
                    })
                );
            });
        }
    }, [selectedGames]);

    return {
        peak,
        avg
    };
};

export default useActiveUsersData;
